import { RegisterTokenOptions } from '@/services/push-gateway';
import { VendorAnalyticsConfig } from '@/services/vendor-analytics/types';

export enum HapticFeedbackTypes {
	impactLight = 'impactLight',
	impactMedium = 'impactMedium',
	impactHeavy = 'impactHeavy',
	rigid = 'rigid',
	soft = 'soft',
	notificationSuccess = 'notificationSuccess',
	notificationWarning = 'notificationWarning',
	notificationError = 'notificationError',
	selection = 'selection' // this one is ios only
}
export type StatusBarStyle = 'light' | 'dark';

export interface AppCustomConfig {
	services: string[];
	brand: string;
	brand_id: string;
	color?: string;
	town?: string | string[];
	appStore?: string;
	discounts?: {
		images: string[];
		buttonImages?: [string, string];
	};
	gradingFilialId?: number;
	booking?: boolean;
	is_menu_button_icons_raw?: boolean;
	is_chocobalance_hidden?: boolean;
	category_ids?: number[];
	analytics?: VendorAnalyticsConfig;
	version?: string;
	app_download_url?: string;
	is_app_disabled?: boolean;
	postMessage(message: string): void;
	openQRScannerWithTextResult?: () => void;
	changeLanguage?: (lang: string) => void;
	setUserID?: (userID: string) => void;
	clearUserID?: () => void;
	haptic?: (type: HapticFeedbackTypes) => void;
	setStatusBarStyle?: (style: StatusBarStyle) => void;
}

export interface AppWebHandler {
	didBecomeActive: () => void;
	didScanQrText: (text: string) => string | void;
	onCameraPermissionDenied: (text: string) => void;
	onBackPressed: () => boolean | void;
	onHandlePushToken: (options: RegisterTokenOptions) => void;
	onOpenNativeNotification: (
		options: RegisterTokenOptions,
		url: string
	) => void;
	onLiveActivityStarted?: (data: {
		activityId: string;
		token: string | null;
	}) => void;
	onLiveActivityError?: (data: { error: string }) => void;
	onLiveActivityTokenUpdated?: (data: { token: string }) => void;
	onLiveActivityEnded?: () => void;
	payWithGooglePay?: (params: {
		amount: number;
		gateway: string;
		gatewayMerchantId: string;
	}) => void;
	onGooglePaySuccess?: (token: string) => void;
	onGooglePayError?: (message: string) => void;
	onGooglePayCancelled?: () => void;
}
